// media queries
window.rootStyles = getComputedStyle(document.body);
window.mq = [
  window.matchMedia('(max-width: ' + rootStyles.getPropertyValue('--xs-max') + ')'),
  window.matchMedia('(min-width: ' + rootStyles.getPropertyValue('--sm-min') + ') and (max-width: ' + rootStyles.getPropertyValue('--sm-max') + ')'),
  window.matchMedia('(min-width: ' + rootStyles.getPropertyValue('--md-min') + ') and (max-width: ' + rootStyles.getPropertyValue('--md-max') + ')'),
  window.matchMedia('(min-width: ' + rootStyles.getPropertyValue('--xl-min') + ')')
];